import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { handleErrorNotification } from 'Common/utils';
import { useApiClient } from 'utils/apiClient';

/* eslint-disable import/prefer-default-export */
export const useDatevAuthentication = (enabled: boolean) => {
  const apiClient = useApiClient();
  return useQuery({
    queryKey: ['datev', 'auth'],
    queryFn: apiClient.Datev.getAccountAuth,
    enabled,
  });
};

export const useRedirectParameters = () => {
  const apiClient = useApiClient();
  return useQuery({
    queryKey: ['datev', 'redirect_params'],
    queryFn: apiClient.Datev.getRedirectParams,
  });
};

export const usePostRedirectResult = () => {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();
  const { locale } = useIntl();
  return useMutation({
    mutationFn: apiClient.Datev.postRedirectResult,
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ['datev', 'auth'] });
    },
    onError: (error: unknown) => {
      handleErrorNotification({
        error,
        lang: locale.toLowerCase(),
      });
    },
  });
};
